export const MUT_SET_ADDRESS_INPUT_TYPE = 'MUT_SET_ADDRESS_INPUT_TYPE';
export const MUT_SET_AUTOCOMPLETE = 'MUT_SET_AUTOCOMPLETE';
export const MUT_SET_AUTOCOMPLETE_DISPLAYED = 'MUT_SET_AUTOCOMPLETE_DISPLAYED';
export const MUT_LOAD_STATE = 'MUT_LOAD_STATE';
export const MUT_RESET = 'MUT_RESET';

